import type { Navigation } from '@toolpad/core/AppProvider';
import CalcIcon from 'icons/CalcIcon';
import DashboardIcon from 'icons/DashboardIcon';
import PersonAddIcon from 'icons/PersonAddIcon';

export const DOCTOR_NAVIGATION: Navigation = [
  {
    kind: 'header',
    title: 'Main menu',
  },
  {
    segment: 'dashboard',
    title: 'Dashboard',
    icon: <DashboardIcon size={14} style={{ color: 'inherit' }} />,
  },
  {
    segment: 'rvus-calculator',
    title: 'RVU Calculator',
    icon: <CalcIcon size={15} style={{ color: 'inherit' }} />,
  },
];
